module.exports = __webpack_public_path__ + "static/media/nexter_small.2f2e382e.webp";